import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import IadaBadge from "@/components/IadaBadge";

/**
 * Fase 13.2.5 · Footer editorial 4 columnas + fila legal.
 * Producto · Empresa · Legal · Redes. Todos los links no implementados
 * apuntan a `/placeholder` (Próximamente).
 */
export default function Footer() {
  return (
    <footer className="border-t border-gray-200 bg-slate-50 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-6">
        <div className="md:col-span-2 space-y-3">
          <Logo />
          <p className="text-sm text-gray-600 max-w-xs leading-relaxed">
            La plataforma de capacitación financiera para instituciones y aliados
            white-label. 195+ programas certificados, IA generativa y reportería
            ejecutiva en un solo stack.
          </p>
          <p className="text-[11px] text-gray-500 mt-4 inline-flex items-center gap-1 px-2 py-1 rounded-full bg-amber-100 border border-amber-300 text-amber-900 font-semibold uppercase tracking-widest">
            Portal en modo demo · pagos y comunicaciones mockeadas
          </p>
        </div>

        <FooterCol title="Soluciones">
          <FooterLink to="/para-instituciones">Para Instituciones</FooterLink>
          <FooterLink to="/para-aliados">Para Aliados</FooterLink>
          <FooterLink to="/placeholder">Para Instructores</FooterLink>
        </FooterCol>

        <FooterCol title="Plataforma">
          <FooterLink to="/catalogo">Catálogo</FooterLink>
          <FooterLink to="/placeholder">Content Studio</FooterLink>
          <FooterLink to="/placeholder">API + Webhooks</FooterLink>
          <FooterLink to="/verificar/00000">Certificados</FooterLink>
        </FooterCol>

        <FooterCol title="Empresa">
          <FooterLink to="/equipo">Nosotros</FooterLink>
          <FooterLink to="/placeholder">Casos de estudio</FooterLink>
          <FooterLink to="/contacto">Contacto</FooterLink>
          <FooterLink to="/placeholder">Prensa</FooterLink>
        </FooterCol>

        <FooterCol title="Legal">
          <FooterLink to="/placeholder">Términos</FooterLink>
          <FooterLink to="/placeholder">Privacidad</FooterLink>
          <FooterLink to="/placeholder">Cookies</FooterLink>
          <FooterLink to="/placeholder">Cumplimiento</FooterLink>
        </FooterCol>
      </div>
      <div className="border-t border-gray-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between flex-wrap gap-4">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} Debt Capital College · Todos los derechos reservados.
          </p>
          <IadaBadge size="sm" />
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, children }) {
  return (
    <div>
      <h4 className="text-xs uppercase tracking-widest text-gray-500 font-semibold mb-4">{title}</h4>
      <ul className="space-y-2.5 text-sm">{children}</ul>
    </div>
  );
}

function FooterLink({ to, children, icon: Icon }) {
  return (
    <li>
      <Link to={to} className="text-[#0B0B0B] hover:text-primary transition-colors inline-flex items-center gap-1.5">
        {Icon && <Icon className="w-3.5 h-3.5" />}
        {children}
      </Link>
    </li>
  );
}
